<template>
    <div>
        <div class="simple-form">
            <div class="form-group center">
                <div class="form-label">
                    <label>文件名称</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-input v-model="img.fileName" class="width-2x" type="text" auto-complete="off"></el-input>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import goodsOrderApi from '../../api/goodsOrder';

    export default {
        name: 'swb-goods-order-img-update',
        desc: '订单附件',
        props: ['id'],
        data: function () {

            return {
                img: {}
            }
        },
        created: function () {
            this.getImgFile();
        },
        methods: {
            getImgFile: function () {
                let self = this;
                let postData = {
                    id: self.id
                }
                goodsOrderApi.getGoodsOrderApdxFileById(postData, function (result) {
                    if(result.type == "info") {
                        self.img = result.data;
                    } else {
                        MsgBox.warning(result.message);
                        return;
                    }
                })
            },
            getDlgResult: function () {
                let result = {};
                let img = this.img;
                if(img.fileName.length > 20){
                    result.type = "warn";
                    result.message = "文件名称不可多于20个字";
                    return result;

                }
                let postData = {
                    fileName: img.fileName
                };
                result.data = postData;
                result.type = "info";
                return result;
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/order/GoodsOrderImgUpdate.vue